export enum ItemStatus {
  ACTIVE = 'ACTIVE',
  PENDING = 'PENDING',
  DISABLED = 'DISABLED',
  DELETED = 'DELETED',
}

export enum DataLegitimacy {
  LEGITIMATE = 'LEGITIMATE',
  ARTIFICIAL = 'ARTIFICIAL',
}

export enum ShapeType {
  POLYGON = 'Polygon',
  MULTI_POLYGON = 'MultiPolygon',
  POINT = 'Point',
}

export enum UnitOfMeasure {
  IMPERIAL = 'imperial',
  SI = 'si',
  CANADA = 'canada',
}

export enum LocaleGroup {
  APPLICATION_DRY = 'area-density.application.dry-fertilizer',
  APPLICATION_LIQUID = 'volumetric-density',
  AREA = 'area',
  CROP_WATER_USE = 'crop-water-use',
  CROP_HEAT_INDEX = 'crop-heat-index',
  ELEVATION = 'elevation',
  EQUIPMENT_SPEED = 'land-speed',
  MOISTURE = 'humidity',
  POPULATION = 'seed-density',
  POPULATION_SHORT = 'seed-density.seed-density-short',
  POPULATION_WEIGHT = 'seed-density.air-seeder',
  RAINFALL = 'rainfall',
  WEIGHT = 'mass',
  WEIGHT_SILAGE = 'yield-dry-mass-silage',
  WEIGHT_YIELD = 'mass.yield',
  WEIGHT_DRY_YIELD = 'yield-dry-mass-silage',
  WEIGHT_SUGARCANE = 'yield-mass-weighted-crop-sugarcane',
  WEIGHT_COTTON = 'yield-dry-mass-cotton',
  YIELD = 'area-density.yield',
  YIELD_SILAGE = 'yield-density-weighted-crop-silage',
  YIELD_SUGARCANE = 'yield-density-weighted-crop-sugarcane',
  YIELD_COTTON = 'yield-density-weighted-crop-cotton'
}

export enum DisplayUnit {
  MACHINE_SPEED = 'land-speed',
  APPLICATION_RATE_BY_MASS = 'application-mass-rate',
  APPLICATION_RATE_BY_VOLUME = 'application-volume-rate',
  APPLICATION_AMOUNT_BY_MASS = 'mass',
  APPLICATION_AMOUNT_BY_VOLUME = 'volume',
}

export type BasicUser = {
  firstName: string;
  lastName: string;
  uuid: string;
};

export type Coordinate = number[][][][] | number[][];

export type Geometry = {
  type: ShapeType.POLYGON;
  coordinates: Coordinate;
}

export type ServerObject = {
  createdAt: string;
  createdBy: number;
  deleted: boolean;
  id?: string;
  updatedAt: string;
  updatedBy: number;
  serverUpdatedAt?: string,
};

export type ServerObjectWithUser = ServerObject & {
  createdByUser: BasicUser;
  updatedByUser: BasicUser;
};

export interface RawMeasurementQU {
  q: number;
  u: string;
}

export interface ValueUnit {
  v: number;
  u: string;
}

export type NamedEntity = {
  id: string;
  name: string;
}

export type EventDates = {
  startDate: number;
  endDate: number;
  year: number;
}

export type EventDatesPartial = {
  startDate?: number;
  endDate?: number;
  year?: number;
}

export type Color = {
  label: string;
  color: string;
}


export enum AsyncStatus {
  IDLE = 'IDLE',
  PENDING = 'PENDING',
  RESOLVED = 'RESOLVED',
  REJECTED = 'REJECTED',
}
